import React from "react";

const MEASURE_COLOR = "#d64545";

const MeasureGuideDiagram = () => (
  <svg
    className="mx-auto w-full max-w-[320px]"
    viewBox="0 0 320 400"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden
  >
    <g fill="none" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round">
      <ellipse cx="160" cy="34" rx="15" ry="17" />
      <path d="M160 51v10" />
      <path d="M126 74c-8 18-10 40-10 62 0 22-6 44-8 66-2 18-3 36-3 54v58M194 74c8 18 10 40 10 62 0 22 6 44 8 66 2 18 3 36 3 54v58" />
      <path d="M126 74h68" />
      <path d="M134 360h20M166 360h20" />
      <path d="M134 360v28M154 360v28M166 360v28M186 360v28" />
      <path d="M148 74c-14 24-16 52-14 80 2 24 8 48 10 72 2 20 2 40 2 60M172 74c14 24 16 52 14 80-2 24-8 48-10 72-2 20-2 40-2 60" />
    </g>

    <g fill="none" stroke={MEASURE_COLOR} strokeWidth="1.6" strokeDasharray="5 4">
      <line x1="118" y1="82" x2="202" y2="82" />
      <ellipse cx="160" cy="132" rx="50" ry="10" />
      <ellipse cx="160" cy="178" rx="38" ry="8" />
      <ellipse cx="160" cy="224" rx="46" ry="10" />
    </g>

    <g fill="#6b6b7c" fontSize="13" fontFamily="-apple-system,BlinkMacSystemFont,'Segoe UI',sans-serif">
      <text x="224" y="86">Shoulder</text>
      <text x="224" y="136">Bust</text>
      <text x="224" y="182">Waist</text>
      <text x="224" y="228">Hips</text>
    </g>
  </svg>
);

const MeasureGuide = ({ showIntro = true, className = "" }) => (
  <div className={className}>
    {showIntro && (
      <div className="mb-6 space-y-2 text-center text-sm leading-relaxed text-secondary">
        <p>Find the size to fit your body measurements in the chart above.</p>
        <p>Here is a handy body measurement guide:</p>
      </div>
    )}
    <MeasureGuideDiagram />
    <p className="mt-5 text-center text-xs leading-relaxed text-secondary">
      Use a soft measuring tape and keep it level for the most accurate fit.
    </p>
    <p className="mt-2 text-center text-xs leading-relaxed text-secondary">
      Measure over light clothing, keep natural posture, and avoid pulling the tape too tight.
    </p>
  </div>
);

export default MeasureGuide;
export { MeasureGuideDiagram };
